import ImageSlider from "../components/ImageSlider";
import React from 'react';
import { Helmet } from 'react-helmet';
import ServicesSection from "../components/SectionSercice";
import QualityProcessSection from "../components/Qualitysection";
import ContactSection from "../components/ContactSection";
import TeamSection from "../components/TeamMember";
import ServicesCards from "../components/ServicesCards";
import DigitalApproach from "../components/DigitalApproach";
import AISection from "../components/AISection";
import ReferencesSection from "../components/ReferencesSection";
import WordCloud from "../components/WordCloud";
export default function AcceuilPage() {
  return (
      <>
        <Helmet>
          <title>Accueil - Aydees | Solutions IT & Conseils</title>
          <meta name="description" content="Aydees propose des solutions IT innovantes, du développement web et mobile, du conseil digital et des formations au Niger. Votre partenaire technologique de confiance." />
          <meta name="keywords" content="Aydees, solutions IT, développement web, mobile, conseil digital, formation, Niger, Niamey" />
        </Helmet>
        {/* Hero Section */}
        <ImageSlider />
        {/* <WordCloud /> */}
        {/* Services Cards Section */}
        <ServicesCards />

        {/* Digital Approach Section */}
        <DigitalApproach />
        <AISection />
        <ServicesSection />
        <QualityProcessSection />
          <TeamSection />
        {/* References Section */}
          <ReferencesSection />
        {/* Contact Form Section */}
          <ContactSection />
      </>
    );
  }
  